import React from 'react';
import { Row, Col, Typography } from 'antd';
import './CallPutOptionsDetails.css';

const { Text } = Typography;

export const hasCallPutFieldValue = (value) => {
  if (value === null || value === undefined) return false;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return false;
  if (
    normalized === 'n.a.'
    || normalized === 'n.a'
    || normalized === 'na'
    || normalized === ';;;na'
    || normalized === ''
    || normalized === 'null'
  ) {
    return false;
  }
  return true;
};

const yn = (value) => (value ? 'Yes' : 'No');

export default function CallPutOptionsDetails({ data }) {
  if (!data) return null;

  const {
    putSpecifiedDates,
    putDiscount,
    putDeadlineDate,
    putNotificationTime,
    putRedemptionDate,
    putAdditionalDetails,
    callSpecifiedDates,
    callDiscount,
    callDeadlineDate,
    callNotificationTime,
    callRedemptionDate,
    callAdditionalDetails,
  } = data;

  const putAvailable = hasCallPutFieldValue(putSpecifiedDates);
  const callAvailable = hasCallPutFieldValue(callSpecifiedDates);

  return (
    <div className="cp-structure">
      <div className="cp-block">
        <div className="cp-block-header">
          <Text className="cp-kicker">PUT OPTION AVAILABLE :</Text>
          <Text className="cp-kicker-value">{yn(putAvailable)}</Text>
        </div>

        {putAvailable && (
          <>
            <div className="cp-subheader">
              <Text className="cp-subheader-text">PUT OPTION DETAILS</Text>
            </div>

            <Row gutter={[24, 16]} className="cp-grid">
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Put Specified Dates</div>
                  <div className="cp-value">{putSpecifiedDates || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Put Notice Deadline Date :</div>
                  <div className="cp-value">{putDeadlineDate || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Put Notification Time :</div>
                  <div className="cp-value">{putNotificationTime || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Put Discount / Premium / Par</div>
                  <div className="cp-value">{putDiscount || 'N/A'}</div>
                </div>
              </Col>
            </Row>

            <Row gutter={[24, 16]} className="cp-grid cp-grid-secondary">
              <Col xs={24} md={12}>
                <div className="cp-field">
                  <div className="cp-label">Redemption Date due to PUT option</div>
                  <div className="cp-value">{putRedemptionDate || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="cp-field">
                  <div className="cp-label">Additional details thereof:</div>
                  <div className="cp-value">{putAdditionalDetails || 'N/A'}</div>
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>

      <div className="cp-divider" aria-hidden />

      <div className="cp-block">
        <div className="cp-block-header">
          <Text className="cp-kicker">CALL OPTION AVAILABLE :</Text>
          <Text className="cp-kicker-value">{yn(callAvailable)}</Text>
        </div>

        {callAvailable && (
          <>
            <div className="cp-subheader">
              <Text className="cp-subheader-text">CALL OPTION DETAILS</Text>
            </div>

            <Row gutter={[24, 16]} className="cp-grid">
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Call Specified Dates:</div>
                  <div className="cp-value">{callSpecifiedDates || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Call Notice Deadline Date:</div>
                  <div className="cp-value">{callDeadlineDate || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Call Notification Time:</div>
                  <div className="cp-value">{callNotificationTime || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="cp-field">
                  <div className="cp-label">Call Discount / Premium / Par</div>
                  <div className="cp-value">{callDiscount || 'N/A'}</div>
                </div>
              </Col>
            </Row>

            <Row gutter={[24, 16]} className="cp-grid cp-grid-secondary">
              <Col xs={24} md={12}>
                <div className="cp-field">
                  <div className="cp-label">Redemption Date due to CALL option</div>
                  <div className="cp-value">{callRedemptionDate || 'N/A'}</div>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="cp-field">
                  <div className="cp-label">Additional details thereof:</div>
                  <div className="cp-value">{callAdditionalDetails || 'N/A'}</div>
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
}
